import { createBrowserRouter } from "react-router-dom";

import indexRouter from "./indexRouter";
import mobileRoutes from "./m.routes";
import devRoutes from "./dev";

const router = createBrowserRouter([indexRouter, mobileRoutes, devRoutes]);

export default router;
